import React, { useEffect, useState } from 'react';
import { Sidebar } from './Sidebar';
import { Gheader } from './Gheader';
import styles from './Deal.module.css';
import DealButton from './DealButton';
import FilterButton from './FilterButton';
import DealTable from './DealTable';
import DealModel from './DealModel';
import apiService from '../api/apiService';

export const Deal = () => {
  const [isDealModelOpen, setIsDealModelOpen] = useState(false);
  const [selectedDeal, setSelectedDeal] = useState(null);
  const [dealData, setDealData] = useState([]);
  const addDeal = newDeal => {
    setDealData([newDeal, ...dealData]);
  };

  useEffect(() => {
    fetchDeals();
  }, []);

  const fetchDeals = async () => {
    try {
      const response = await apiService.get('/deals/');
      setDealData(response);
    } catch (error) {
      console.log(error);
    }
  };

  const addOrUpdateDeal = async newDeal => {
    console.log(newDeal);
    /* try {
      if (newDeal.id) {
        await apiService.put(`/deals/${newDeal.id}`, newDeal);
      } else {
        // Call create API when adding a new deal
        await apiService.post('/deals/', newDeal);
      }

      setDealData(prevDeals => {
        const existingDeal = prevDeals.find(
          deal => deal.reference_number === newDeal.reference_number
        );
        if (existingDeal) {
          return prevDeals.map(deal =>
            deal.reference_number === newDeal.reference_number ? newDeal : deal
          );
        }
        return [newDeal, ...prevDeals];
      });
    } catch (error) {
      console.log('Failed to add or update deal:', error);
    } */
  };

  const deleteDeal = dealId => {
    setDealData(prevDeals => prevDeals.filter(deal => deal.id !== dealId));
  };

  return (
    <div className={styles.gheader}>
      <div className={styles.dashboardContainer}>
        <Sidebar />
        <div className={styles.mainContent}>
          <Gheader />
          <h3>Deal</h3>

          <div className={styles.buttonContainer}>
            <DealButton />
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <button
                className={styles.addDealButton}
                onClick={() => {
                  setSelectedDeal(null);
                  setIsDealModelOpen(true);
                }}
              >
                Add deal
              </button>
              <FilterButton />
            </div>
          </div>

          <DealTable
            deals={dealData}
            setDealData={setDealData}
            onEdit={deal => {
              setSelectedDeal(deal);
              setIsDealModelOpen(true);
            }}
            onDelete={deleteDeal}
          />
        </div>
      </div>

      <DealModel
        isOpen={isDealModelOpen}
        onClose={() => setIsDealModelOpen(false)}
        onSave={addDeal}
        initialData={selectedDeal}
      />
    </div>
  );
};

export default Deal;
